import { Column } from '@app/modules/table/classes/column.class';
import { CellDisplay } from '@app/modules/table/enums/cell-display.enum';

export class TitleColumn extends Column {
    title = 'employees.records.title';
    property = 'title';
    type: CellDisplay = CellDisplay.string;
    sortable = true;
}
